export default {
  getMedicalDeviceRiskClass: (state) => state.medicalDeviceRiskClass,
};
